import { render } from "./QrGenerator.vue?vue&type=template&id=4789c54e&scoped=true"
import script from "./QrGenerator.vue?vue&type=script&lang=js"
export * from "./QrGenerator.vue?vue&type=script&lang=js"

import "./QrGenerator.vue?vue&type=style&index=0&id=4789c54e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4789c54e"]])

export default __exports__